import {DecoratedWebinar} from './webinars-admin.types';

export type WebinarScheduleSortDirection = 'asc' | 'desc' | '';

export function getScheduleDateTime(input: string | Date | null | undefined): number | null {
    if (!input) {
        return null;
    }

    const time = input instanceof Date ? input.getTime() : new Date(input).getTime();
    return Number.isFinite(time) ? time : null;
}

export function compareWebinarScheduleDate(
    a: DecoratedWebinar,
    b: DecoratedWebinar,
    direction: Exclude<WebinarScheduleSortDirection, ''>,
): number {
    const aTime = getScheduleDateTime(a.scheduledAt);
    const bTime = getScheduleDateTime(b.scheduledAt);

    if (aTime === null && bTime === null) {
        return 0;
    }

    if (aTime === null) {
        return 1;
    }

    if (bTime === null) {
        return -1;
    }

    return direction === 'asc' ? aTime - bTime : bTime - aTime;
}

export function sortWebinarsByScheduleDate(
    webinars: DecoratedWebinar[],
    direction: WebinarScheduleSortDirection,
): DecoratedWebinar[] {
    if (direction !== 'asc' && direction !== 'desc') {
        return webinars;
    }

    return webinars
        .map((webinar, index) => ({webinar, index}))
        .sort((a, b) => {
            const result = compareWebinarScheduleDate(a.webinar, b.webinar, direction);
            return result === 0 ? a.index - b.index : result;
        })
        .map(({webinar}) => webinar);
}
